/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Partner_Org_Contract_State_UnapprovedInputs */



/**
* | output |
* | --- |
* | "Not approved. The term begins {date}, but this organization will stay asleep — and nobody in it can sign in — until a super-admin approves it." |
*
* @param {Partner_Org_Contract_State_UnapprovedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_org_contract_state_unapproved = /** @type {((inputs: Partner_Org_Contract_State_UnapprovedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Org_Contract_State_UnapprovedInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Nicht genehmigt. Die Laufzeit beginnt am ${i?.date}, die Organisation bleibt jedoch inaktiv — und niemand kann sich anmelden — bis ein Super-Admin sie genehmigt.`)
	return /** @type {LocalizedString} */ (`Not approved. The term begins ${i?.date}, but this organization will stay asleep — and nobody in it can sign in — until a super-admin approves it.`)
});